import { render, staticRenderFns } from "./ProjectBrief.vue?vue&type=template&id=00dd3e13&scoped=true"
import script from "./ProjectBrief.vue?vue&type=script&lang=js"
export * from "./ProjectBrief.vue?vue&type=script&lang=js"
import style0 from "./ProjectBrief.vue?vue&type=style&index=0&id=00dd3e13&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00dd3e13",
  null
  
)

export default component.exports